module.exports = __webpack_public_path__ + "static/1-db5fa10412a60ae469715e0e7f9d2c73.jpg";